import { useRouter } from 'next/router'
import { useState } from 'react'
import { MapSearchTagAddInput as Input } from 'ui-components'
import { getSearchQuery } from 'utils'

import { useTags } from '~map-search/hooks/useTags'
import { useSearchTags } from '~map-search/queries/useSearchTags'
import { Tag } from '~map-search/types/__generated/gql/graphql'

export function MapSearchTagAddInput() {
  const router = useRouter()
  const tags = useTags()

  const [value, setValue] = useState<Tag>()
  const [inputValue, setInputValue] = useState('')

  const { data } = useSearchTags({
    query: inputValue,
    from: 0,
    size: 10
  })

  const createTag = () => {
    const previousTags = tags.map((tag) => tag.id)
    router.push(
      getSearchQuery({
        tags: [...previousTags, ...(value?.id ? [value.id] : [])]
      }),
      undefined,
      { shallow: true }
    )
  }

  const reset = () => {
    setInputValue('')
  }

  const handleInputChange = (event, value) => {
    setInputValue(value)
  }

  const handleApply = () => {
    createTag()
    reset()
  }

  const handleEnter = () => {
    createTag()
    reset()
  }

  const handleChange = (event, value) => {
    setValue(value)
  }

  return (
    <Input
      inputValue={inputValue}
      options={data?.items || []}
      getOptionLabel={(option) => option.name}
      onInputChange={handleInputChange}
      onChange={handleChange}
      onApply={handleApply}
      onEnter={handleEnter}
    />
  )
}
